// extracted by mini-css-extract-plugin
module.exports = {"modalFooterButtons":"ShippingFormWeightEditionModal_modalFooterButtons__3B68X"};